// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".foraUso[data-v-07aa5893]{background-color:#dc3545}.emUso[data-v-07aa5893],.foraUso[data-v-07aa5893]{color:#fff;font-weight:700;text-align:center}.emUso[data-v-07aa5893]{background-color:#28a745}", ""]);
// Exports
module.exports = exports;
